import api from '../../../utils/api';

export async function discoverClubs({
  latitude,
  longitude,
  radiusMiles = 40,
  acceptingOnly = false,
  keyword = '',
  sort = 'distance',
}) {
  const params = {
    latitude,
    longitude,
    radius_miles: radiusMiles,
    sort,
  };
  if (acceptingOnly) params.accepting_only = 'true';
  if (keyword?.trim()) params.keyword = keyword.trim();

  const res = await api.get('/clubs/discover/', { params });
  return res.data;
}

export async function fetchDiscoverClubDetail(clubId, { latitude, longitude } = {}) {
  const params = {};
  if (typeof latitude === 'number' && typeof longitude === 'number') {
    params.latitude = latitude;
    params.longitude = longitude;
  }
  const res = await api.get(`/clubs/discover/${clubId}/`, { params });
  return res.data;
}
